// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Ddiz","requiredAsterisk":"Info_requiredAsterisk__2WzgJ"};